import { Swiper, SwiperSlide } from 'swiper/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faJs, faReact, faSass } from '@fortawesome/free-brands-svg-icons'
import { Navigation, Pagination } from 'swiper'
import data from '../../../slider.json'
import { motion } from 'framer-motion'

const Slider = ({
	type,
}: {
	type: 'web' | 'graphic' | 'development' | '3d' | 'videos'
}) => {
	return (
		<Swiper
			spaceBetween={100}
			slidesPerView={1}
			allowTouchMove={true}
			modules={[Navigation, Pagination]}
			className="slider"
			navigation={{
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			}}
			pagination={{
				clickable: true,
				type: 'bullets',
				el: '.swiper-pagination',
			}}
		>
			{data[type].map((item: any, i: number) => {
				return (
					<SwiperSlide key={i}>
						<motion.div
							initial={{ opacity: 0, scale: 0.5 }}
							animate={{
								opacity: true ? 1 : 0,
								scale: true ? 1 : 0.5,
							}}
							className="slide"
						>
							<div className="img">
								{item.image && <img src={item.image} alt={item.title} />}
								{item.video && (
									<iframe
										src={item.video}
										title="YouTube video player"
										frameBorder="0"
										allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
										allowFullScreen
									></iframe>
								)}
							</div>
							<div className="info">
								<div className="index">
									<span className="titleIndex">
										{i >= 10 ? i + 1 : `0${i + 1}`}
									</span>
									{item.url ? (
										<a className="title" href={item.url} target="_blank">
											{item.title}
										</a>
									) : (
										<span className="title">{item.title}</span>
									)}
								</div>
								<h2 className="type">{item.type}</h2>
								<div className="tools">
									{item.tools.map((tool: string, j: number) => (
										<span key={j}>
											{tool === 'react' && <FontAwesomeIcon icon={faReact} />}
											{tool === 'sass' && <FontAwesomeIcon icon={faSass} />}
											{tool === 'js' && <FontAwesomeIcon icon={faJs} />}
											{tool === 'lua' && (
												<span>
													<svg
														role="img"
														viewBox="0 0 24 24"
														xmlns="http://www.w3.org/2000/svg"
														style={{
															width: 40,
															height: 40,
														}}
													>
														<path d="M.38 10.377l-.272-.037c-.048.344-.082.695-.101 1.041l.275.016c.018-.34.051-.682.098-1.02zM4.136 3.289l-.184-.205c-.258.232-.509.48-.746.734l.202.188c.231-.248.476-.49.728-.717zM5.769 2.059l-.146-.235c-.296.186-.586.385-.863.594l.166.219c.27-.203.554-.399.843-.578zM1.824 18.369c.185.297.384.586.593.863l.22-.164c-.205-.271-.399-.555-.58-.844l-.233.145zM1.127 16.402l-.255.104c.129.318.274.635.431.943l.005.01.245-.125-.005-.01c-.153-.301-.295-.611-.421-.922zM.298 9.309l.269.063c.076-.332.168-.664.272-.986l-.261-.087c-.108.332-.202.672-.28 1.01zM.274 12.42l-.275.01c.012.348.04.699.083 1.043l.273-.033c-.042-.336-.069-.68-.081-1.02zM.256 14.506c.073.34.162.682.264 1.014l.263-.08c-.1-.326-.187-.658-.258-.99l-.269.056zM11.573.275L11.563 0c-.348.012-.699.039-1.044.082l.034.273c.338-.041.68-.068 1.02-.08zM23.221 8.566c.1.326.186.66.256.992l.27-.059c-.072-.34-.16-.682-.262-1.014l-.264.081zM17.621 1.389c-.309-.164-.627-.314-.947-.449l-.107.252c.314.133.625.281.926.439l.128-.242zM15.693.572c-.332-.105-.67-.199-1.01-.277l-.063.268c.332.076.664.168.988.273l.085-.264zM6.674 1.545c.298-.15.606-.291.916-.418L7.486.873c-.317.127-.632.272-.937.428l-.015.008.125.244.015-.008zM23.727 11.588l.275-.01a11.797 11.797 0 0 0-.082-1.045l-.273.033c.041.338.068.682.08 1.022zM13.654.105c-.346-.047-.696-.08-1.043-.098l-.014.273c.339.018.683.051 1.019.098l.038-.273zM9.544.527l-.058-.27c-.34.072-.681.16-1.014.264l.081.262c.325-.099.659-.185.991-.256zM1.921 5.469l.231.15c.185-.285.384-.566.592-.834l-.217-.17c-.213.276-.417.563-.606.854zM.943 7.318l.253.107c.132-.313.28-.625.439-.924l-.243-.128c-.163.307-.314.625-.449.945zM18.223 21.943l.145.234c.295-.186.586-.385.863-.594l-.164-.219c-.272.204-.557.4-.844.579zM21.248 19.219l.217.17c.215-.273.418-.561.607-.854l-.23-.148c-.186.285-.385.564-.594.832zM19.855 20.715l.184.203c.258-.23.51-.479.746-.732l-.201-.188c-.23.248-.477.488-.729.717zM22.359 17.504l.244.129c.162-.307.314-.625.449-.945l-.254-.107a11.27 11.27 0 0 1-.439.923zM23.617 13.629l.273.039c.049-.346.082-.695.102-1.043l-.275-.014c-.018.338-.051.682-.1 1.018zM23.156 15.621l.264.086c.107-.332.201-.67.279-1.01l-.268-.063c-.077.333-.169.665-.275.987zM22.453 6.672c.154.303.297.617.424.932l.256-.104c-.131-.322-.277-.643-.436-.953l-.244.125zM8.296 23.418c.331.107.67.201 1.009.279l.062-.268c-.331-.076-.663-.168-.986-.273l-.085.262zM10.335 23.889c.345.049.696.082 1.043.102l.014-.275c-.339-.018-.682-.051-1.019-.098l-.038.271zM17.326 22.449c-.303.154-.613.297-.926.424l.104.256c.318-.131.639-.275.947-.434l.004-.002-.123-.246-.006.002zM4.613 21.467c.274.213.562.418.854.605l.149-.23c-.285-.184-.565-.385-.833-.592l-.17.217zM12.417 23.725l.009.275c.348-.014.699-.041 1.045-.084l-.035-.271c-.336.041-.68.068-1.019.08zM6.37 22.604c.307.162.625.314.946.449l.107-.254c-.313-.133-.624-.279-.924-.439l-.129.244zM3.083 20.041c.233.258.48.51.734.746l.188-.201c-.249-.23-.49-.477-.717-.729l-.205.184zM14.445 23.475l.059.27c.34-.074.68-.162 1.014-.266l-.082-.262c-.325.099-.659.185-.991.258zM21.18.129A2.689 2.689 0 1 0 21.18 5.507 2.689 2.689 0 1 0 21.18.129zM15.324 15.447c0 .471.314.66.852.66.67 0 1.297-.396 1.297-1.016v-.645c-.23.107-.379.141-1.107.24-.735.109-1.042.306-1.042.761zM12 2.818c-5.07 0-9.18 4.109-9.18 9.18 0 5.068 4.11 9.18 9.18 9.18 5.07 0 9.18-4.111 9.18-9.18 0-5.07-4.11-9.18-9.18-9.18zm-2.487 13.77H5.771v-6.023h.769v5.346h2.974v.677zm4.13 0h-.619v-.67c-.405.57-.811.793-1.446.793-.843 0-1.38-.463-1.38-1.182v-3.271h.686v3c0 .52.347.85.893.85.719 0 1.181-.578 1.181-1.461v-2.389h.686v4.33zm-.53-8.393c0-1.484 1.205-2.689 2.689-2.689s2.688 1.205 2.688 2.689-1.203 2.688-2.688 2.688-2.689-1.203-2.689-2.688zm5.567 7.856v.52c-.223.059-.33.074-.471.074-.34 0-.637-.238-.711-.57-.381.406-.918.637-1.471.637-.877 0-1.422-.463-1.422-1.248 0-.527.256-.916.76-1.123.266-.107.414-.141 1.389-.264.545-.066.719-.191.719-.48v-.182c0-.412-.348-.645-.967-.645-.645 0-.957.24-1.016.77h-.693c.041-1 .686-1.404 1.734-1.404 1.066 0 1.627.412 1.627 1.182v2.412c0 .215.133.338.373.338.041-.002.074-.002.149-.017z" />
													</svg>
												</span>
											)}
											{tool === 'blender' && (
												<img
													src="https://i.imgur.com/9JQjJVg.png"
													alt="blender"
													width="40px"
													height="40px"
												/>
											)}
											{tool === 'ai' && (
												<img
													src="https://i.imgur.com/KTXVHUp.png"
													alt="illustrator"
													width="40px"
													height="40px"
												/>
											)}
											{tool === 'ae' && (
												<img
													src="https://i.imgur.com/BDLjU1g.png"
													alt="after effects"
													width="40px"
													height="40px"
												/>
											)}
											{tool === 'ps' && (
												<img
													src="https://i.imgur.com/jMzcDVo.png"
													alt="photoshop"
													width="40px"
													height="40px"
												/>
											)}
											{tool === 'pr' && (
												<img
													src="https://i.imgur.com/ezqq22l.png"
													alt="premier"
													width="40px"
													height="40px"
												/>
											)}
											{tool === 'marvelous' && (
												<img
													src="https://i.imgur.com/nhtqf7i.png"
													alt="premier"
													width="40px"
													height="40px"
												/>
											)}
											{tool === 'unreal' && (
												<img
													src="https://i.imgur.com/0PBuUYW.png"
													alt="premier"
													width="40px"
													height="40px"
												/>
											)}
										</span>
									))}
								</div>
								<p className="desc">{item.description}</p>
							</div>
						</motion.div>
					</SwiperSlide>
				)
			})}
		</Swiper>
	)
}

export default Slider
